import React from "react";
import { Button, Tip } from "grommet";
import { Wifi } from "grommet-icons";
import { EKeyService } from "@services";
import { presentToastSuccess, presentToastErrorContent } from "@shared/Toast";
import { presentLoading, dismissLoading } from "@shared/Loading";
import { presentAlertPrompt } from "@shared/Alert";
import { useTranslation } from "react-i18next";

const RemoteUnlockButton = ({ door, disabled = false }) => {
  const { t } = useTranslation();
  const getDoorDisplayName = () => {
    if (!door) return "";
    return door.type === "room"
      ? t("accessList.roomName", { room: door.name })
      : door.name;
  };

  const handleClick = () => {
    if (!door) return;

    presentAlertPrompt({
      title: t("remoteUnlock.title"),
      message: t("remoteUnlock.confirmMessage", { door: getDoorDisplayName() }),
      onOK: performRemoteUnlock,
      buttonOKText: t("remoteUnlock.unlock"),
      buttonOKColor: "brand",
    });
  };

  const performRemoteUnlock = async () => {
    try {
      presentLoading();
      await EKeyService.remoteUnlock(door._id);
      dismissLoading();
      presentToastSuccess(
        t("remoteUnlock.sent", { door: getDoorDisplayName() })
      );
    } catch (error) {
      dismissLoading();
      presentToastErrorContent(error);
    }
  };

  return (
    <Tip content={t("remoteUnlock.title")}>
      <Button
        icon={<Wifi color="white" size="small" />}
        onClick={handleClick}
        disabled={disabled}
        color="blue-1"
        primary
      />
    </Tip>
  );
};

export default RemoteUnlockButton;
